module.exports = __webpack_public_path__ + "img/size.35f8adef.png";